<script>
import APIStore from '@app/services/API/Store';

export default {
  i18n: {
    messages: {
      fr: {
        test: {
          succeeded: `
            <strong>Test de l'envoi réussi !</strong>
            <br>
            Vérifiez les données reçues chez votre fournisseur de WebHook
            (Zapier, Make...).
          `,
        },
      },
    },
  },
  data() {
    return {
      isLoading: false,
      membership: {
        feature_options: {
          webhooks: {
            subscription_created: '',
            subscription_cancelled: '',
            subscription_renewed: '',
          },
        },
      },
    };
  },
  computed: {
    currentMembership() {
      return this.$store.state.memberships.current;
    },
    authStore() {
      return this.$store.getters['auth/store'];
    },
  },
  created() {
    this.hydrate();
  },
  methods: {
    hydrate() {
      const currentOptions = this.currentMembership.feature_options || {};
      const currentWebhooks = currentOptions.webhooks || {};

      this.membership.feature_options = {
        ...currentOptions,
        webhooks: {
          subscription_created: currentWebhooks.subscription_created || '',
          subscription_cancelled: currentWebhooks.subscription_cancelled || '',
          subscription_renewed: currentWebhooks.subscription_renewed || '',
        },
      };
    },
    handle() {
      const membershipData = { ...this.membership };

      this.isLoading = true;
      this.$store
        .dispatch('memberships/update', {
          uuid: this.currentMembership.uuid,
          membershipData,
          isCurrent: true,
        })
        .then(() => this.$showMessage.success())
        .finally(() => (this.isLoading = false));
    },
    testWebhook(webhook) {
      const url = this.membership.feature_options.webhooks[webhook];

      const loader = this.$buefy.loading.open({ container: this.$refs.form });
      APIStore.testWebhook(this.authStore.uuid, { url, webhook })
        .then(() => this.$buefy.dialog.alert(this.$t('test.succeeded')))
        .finally(() => loader.close());
    },
  },
};
</script>

<template>
  <AppFeatureWrapper>
    <template #title>
      Configurez vos WebHooks avec Zapier, Make...
      <AppFeatureBadge class="ml-2" position="is-right" />
    </template>
    <template #content>
      <p>
        Vous avez envie de créer des automatisations ou procédures ?
      </p>
      <p>
        Les WebHooks (crochets web) sont ce qu'il vous faut ! Teachizy enverra
        des informations à <strong>Zapier</strong>, <strong>Make</strong> ou
        tout <strong>autre service</strong> qui fournit une URL
        <strong>de WebHook</strong>.
      </p>
      <p>
        Pour commencer à automatiser vos procédures, vous pouvez suivre notre
        tutoriel en
        <a
          class="tdecoration-underline has-text-weight-bold"
          href="https://youtu.be/Fw39W9eMTd0"
          target="_blank"
          rel="noreferrer noopener"
        >
          cliquant ici
        </a>
      </p>
    </template>
    <template #form>
      <form
        ref="form"
        class="box is-relative"
        @submit.prevent="dataIsValid(isLoading) && handle()"
      >
        <GoProWrapper :has-sep="false">
          <div class="columns is-multiline is-align-items-flex-end">
            <div class="column is-12 mb-0">
              <b-field label="WebHook déclenché à l'achat de cet abonnement">
                <b-input
                  placeholder="Entrez une URL"
                  pattern="^https?://.+"
                  expanded
                  v-model="
                    membership.feature_options.webhooks.subscription_created
                  "
                />
                <p class="control">
                  <b-tooltip position="is-top" multilined>
                    <template #content>
                      Cliquez pour envoyer des données de test au WebHook, afin
                      de valider son bon fonctionnement
                    </template>
                    <b-button
                      class="has-text-weight-bold"
                      :disabled="
                        !membership.feature_options.webhooks
                          .subscription_created
                      "
                      expanded
                      @click="testWebhook('subscription_created')"
                    >
                      Tester le webhook
                    </b-button>
                  </b-tooltip>
                </p>
              </b-field>
            </div>

            <div class="column is-12 mb-0">
              <b-field label="WebHook déclenché à l'annulation de l'abonnement">
                <b-input
                  placeholder="Entrez une URL"
                  pattern="^https?://.+"
                  expanded
                  v-model="
                    membership.feature_options.webhooks.subscription_cancelled
                  "
                />
                <p class="control">
                  <b-tooltip position="is-top" multilined>
                    <template #content>
                      Cliquez pour envoyer des données de test au WebHook, afin
                      de valider son bon fonctionnement
                    </template>
                    <b-button
                      class="has-text-weight-bold"
                      :disabled="
                        !membership.feature_options.webhooks
                          .subscription_cancelled
                      "
                      expanded
                      @click="testWebhook('subscription_cancelled')"
                    >
                      Tester le webhook
                    </b-button>
                  </b-tooltip>
                </p>
              </b-field>
            </div>

            <div class="column is-12 mb-0">
              <b-field
                label="WebHook déclenché au renouvellement de l'abonnement"
              >
                <b-input
                  placeholder="Entrez une URL"
                  pattern="^https?://.+"
                  expanded
                  v-model="
                    membership.feature_options.webhooks.subscription_renewed
                  "
                />
                <p class="control">
                  <b-tooltip position="is-top" multilined>
                    <template #content>
                      Cliquez pour envoyer des données de test au WebHook, afin
                      de valider son bon fonctionnement
                    </template>
                    <b-button
                      class="has-text-weight-bold"
                      :disabled="
                        !membership.feature_options.webhooks
                          .subscription_renewed
                      "
                      expanded
                      @click="testWebhook('subscription_renewed')"
                    >
                      Tester le webhook
                    </b-button>
                  </b-tooltip>
                </p>
              </b-field>
            </div>
          </div>
          <b-field class="has-text-right">
            <b-button
              type="is-primary"
              native-type="submit"
              :loading="isLoading"
            >
              Mettre à jour
            </b-button>
          </b-field>
        </GoProWrapper>
      </form>
    </template>
  </AppFeatureWrapper>
</template>
